import React from 'react';

const CustomPersona = (props) => {
  return (
    <React.Fragment>
      <div className="page-block-header slds-p-top_x-small slds-m-bottom_large">
        <span className="slds-text-heading_large page-block-header-title">
          <span style={{ color: '#E2796A' }}>Custom</span> Persona Builder
        </span>
      </div>
    </React.Fragment>
  );
};

export default CustomPersona;
